import React,  { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";


import { Checkbox, TextField,MenuItem } from "@material-ui/core";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { createLocation
  ,getBusinessEntities, getAccounts, getAccountTypes, getProcedureTypes,getLocations, getStates,getDistrict,updateMaster
} from "../../crud/auth.crud";

import CodeExample from "../../partials/content/CodeExample";
import InputLabel from '@material-ui/core/InputLabel';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {format} from 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import  IconButton from "@material-ui/core/IconButton";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import EditIcon from '@material-ui/icons/Edit';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Button from '@material-ui/core/Button';


import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';


function AddLocation(props) {
  
  //console.log('Loaded CreateUser',props);
  
  const { intl } = props;
   
   let isLoaded = false;

const [addOpen, setAddOpen] = useState(false);
const [editOpen, setEditOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "2.5rem"
  });

 // const [user,setUser] =useState({});

  const [countryCode,setCountryCode] =useState('USA');
  const [countryName,setCountryName] =useState('United States of America');
  const [stateCode,setStateCode] =useState(null);
  const [stateName,setStateName] =useState(null);
  const [districtCode,setDistrictCode] =useState(null);
  const [districtName,setDistrictName] =useState(null);

  const [selDistrict,setSelDistrict] = useState(null);
  const [selState,setSelState] = useState(null);
 
  let propsAcc =  null;
  if(props.location.data!== undefined && props.location.data!==null && props.location.data.account!==undefined && props.location.data.account!==null) 
    {
      ///console.log(props.location.data.account);
      propsAcc =  props.location.data.account;
    }
    else
    {
      propsAcc ={};
    }

 const [account,setAccount] =useState(propsAcc);
  



  const [accounts,setAccounts] =useState({account:[]});

  const [locations,setLocations] =useState([]);



  
 const [districts,setDistricts] = useState([]);
 const stateChange = async (event,newValue) => {
    if(event !==null && newValue !==null)
    {
      //console.log("statechnage:::",event );
      //console.log("location:::",location);

      const districtresp = await getDistrict(newValue.stateCode)
      setStateCode(newValue.stateCode);
      setStateName(newValue.stateName);
      location.stateCode = newValue.stateCode;
      location.stateName =  newValue.stateName;
      states.filter(x=>x.stateCode === location.stateCode).map((s)=>(
        location.states = s
      ));
      location.districts={};
      console.log("new locaion :::::",location);
      setDistricts(districtresp.data);
      //setLocation(location);
     
      
    }
  
}

const districtChange = async (event,newValue) => {
  if(event!==null && newValue!==null)
  {
    //console.log("districtchnage:::",event );
    setDistrictCode(newValue.districtCode);
    setDistrictName(newValue.districtName);

    location.districtCode = newValue.districtCode;
    location.districtName =  newValue.districtName;
    districts.filter(x=>x.districtCode === location.districtCode).map((s)=>(
      location.districts = s
    ));
    console.log("new locaion :::::",location);
    //setLocation(location);
   
  }
  
}

 React.useEffect(() => {
        const fetchLocations = async () => {
            try {
                console.log("datatime::::",new Date());
                if(account.accountId!==undefined && account.accountId!==null)
                {
                  const response = await getLocations(1,100,'locationName','asc',{accountKey:account.accountId})
                  setLocations(response.data);
                }
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchLocations();
    }, []);

 const [states,setStates] = useState([]);

  React.useEffect(() => {
        const fetchStates = async () => {
            try {
                
               
                  const response = await getStates('USA');
                  setStates(response.data);
               
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchStates();
    }, []);

   


  const [statusColor, setStatusColor] = useState('alert-success');

  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };


const deleteLocation = (index) => {
    locations.splice(index, 1)
    setLocations(locations);
  }

const [location,setLocation] = useState({})
  const editLocation = async (loc) => {
    console.log("edit location",loc);
   
    if(loc.stateCode!==null && loc.stateCode!==undefined)
    {
      states.filter(x=>x.stateCode === loc.stateCode).map((s)=>(
        loc.states = s,
        setStateCode(s.stateCode),
        setStateName(s.stateName),
        setSelState(s)
      ));

    }
    if(loc.districtCode!==null && loc.districtCode!==undefined)
    {
      const districtresp = await getDistrict(loc.stateCode);
      setDistricts(districtresp.data);
      districtresp.data.filter(x=>x.districtCode === loc.districtCode).map((s)=>(
        loc.districts = s,
        setDistrictCode(s.districtCode),
        setDistrictName(s.districtName),
        setSelDistrict(s)
      ));
      
    }
    console.log("final loc:::::",loc);
    setLocation(loc);
    setAddOpen(true);
  }

  const handleAddClose = () => {

    setAddOpen(false);
  }

function handleAddOpen(){
  setLocation({});
   setAddOpen(true);
}

const handleEditClose = () => {

    setEditOpen(false);
  }



  return (

            <>
              <div className="row">
                 <div className="kt-portlet">
                      <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                          <h3 className="kt-portlet__head-title">
                            {account.accountName + " Location's"}
                          </h3>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                          <div className="kt-portlet__head-group">
                            <div className="btn-group">
                              <button type="button" className="btn btn-elevate btn-primary" onClick={ handleAddOpen } data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="la la-plus"></i> Add Location
                              </button>
                              
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="kt-portlet__body">
                        <div className="kt-section">
                          <div className="kt-section__content">
                        {locations.length>0 && 
                          <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                              <TableHead>
                                <TableRow>
                                  <TableCell align="left">Location Name</TableCell>
                                  <TableCell align="left">Address</TableCell>
                                  <TableCell align="left">County</TableCell>
                                  <TableCell align="left">State</TableCell>
                                  <TableCell align="left">Phone</TableCell>
                                  <TableCell align="left">Email</TableCell>
                                   <TableCell align="left">Edit</TableCell>
                                   {/*<TableCell align="left">Delete</TableCell>*/}

                                </TableRow>
                              </TableHead>
                              <TableBody>
                              {locations.map((loc, index) => (
                                <TableRow key={index}>
                                  <TableCell align="left">
                                  {loc.locationName} 
                                   </TableCell>
                                  <TableCell align="left">
                                  {loc.address}                
                                  </TableCell>
                                  <TableCell align="left">
                                  {loc.districtName}                 
                                  </TableCell>
                                  <TableCell align="left">
                                  {loc.stateName}
                                     </TableCell>
                                  <TableCell align="left"> 
                                  {loc.phone}          
                                    </TableCell>
                                  <TableCell align="left"> 
                                  {loc.email}          
                                    </TableCell>
                                    <TableCell align="left">
                                     <IconButton onClick={() => editLocation(loc)}>
                                        <EditIcon style={{ color: '#5578eb',fontSize: 25}}/>   
                                      </IconButton>
                                  </TableCell>
                                  {/*<TableCell align="left">
                                     <IconButton onClick={() => deleteLocation(index)}>
                                        <HighlightOffIcon style={{ color: '#5578eb',fontSize: 25}}/>   
                                      </IconButton>
                                  </TableCell>*/}
                                </TableRow>
                              ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                         }

                          </div>
                        </div>
                      </div>
                  </div>
                </div>

                <Dialog open={addOpen} onClose={handleAddClose} aria-labelledby="form-dialog-title">
 
                    
                    <DialogContent>
                         <Formik
                      initialValues={{
                        locationName: location.locationName,
                        address: location.address,
                        phone:location.phone,
                        email:location.email,
                        //stateCode:location.states,
                        //districtCode:location.districts,
                       // stateCode:selState,
                      //districtCode:selDistrict,
                        //locationKey:location.locationKey
                                      
                      }}
                      validate={values => {
                        const errors = {};

                        
                        if (!values.locationName) {
                          errors.locationName = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                          });
                        }

                        if (!values.address) {
                          errors.address = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                          });
                        }


                        if (!values.phone) {
                          errors.phone = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                          });
                        }

                        

                         
                    
                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting, setExpiryDate }) => {

                    enableLoading();
                    console.log("edit location 1:::::::",location);
                    if(location.locationKey!==null && location.locationKey!==undefined)
                    {
                      console.log("edit location",location);
                      let locationObj ={
                        locationName: values.locationName,
                        address:values.address,
                        phone:values.phone,
                        email:values.email,
                        stateCode:stateCode,
                        stateName:stateName,
                        districtCode:districtCode,
                        districtName:districtName
                      }
                      updateMaster('location',location.locationKey,locationObj)
                      .then(resp => {
                          //props.register(accessToken);
                          console.log(resp);
                          setSubmitting(false);
                           setLocation({});
                            setDistrictCode(null);
                            setDistrictName(null);
                            setStateCode(null);
                            setStateName(null);
                            disableLoading();
                            setSubmitting(false);
                            let allLocations = [];
                            allLocations = locations;
                            console.log("aaal locatiokns:::",locations);
                            let locationIndex = locations.findIndex(el => el.locationKey == location.Key);

                            allLocations[locationIndex] = {...allLocations[locationIndex], locationName: values.locationName};
                            allLocations[locationIndex] = {...allLocations[locationIndex], address:values.address};
                            allLocations[locationIndex] = {...allLocations[locationIndex], phone:values.phone};
                            allLocations[locationIndex] = {...allLocations[locationIndex], email:values.email};
                            allLocations[locationIndex] = {...allLocations[locationIndex], stateCode:stateCode};
                            allLocations[locationIndex] = {...allLocations[locationIndex], stateName:stateName};
                            allLocations[locationIndex] = {...allLocations[locationIndex], districtCode:districtCode};
                            allLocations[locationIndex] = {...allLocations[locationIndex], districtName:districtName};
                            
                            setLocations(allLocations);

                            setStatus(
                              intl.formatMessage({
                                id: "CREATION.SUCCESS.MESSAGE"
                              })
                            );
                            setStatusColor('alert-success');
                            window.scrollTo(0,0);
                            setAddOpen(false);
                          
                         
                        })
                        
                     
                    }
                    else
                    {
                      createLocation(
                        values.locationName,
                        account.accountId,
                        values.address,
                        values.phone,
                        values.email,
                        countryCode,
                        countryName,
                        stateCode,
                        stateName,
                        districtCode,
                        districtName
                        )
                        .then(resp => {
                          //props.register(accessToken);
                          console.log(resp);
                          setSubmitting(false);
                          if(resp.data === 'patientIdPrefix already exists')
                          {
                            disableLoading();
                            setStatus(intl.formatMessage({
                                id: "ACCOUNT.DUPLICATE.MESSAGE"
                              }));
                            setStatusColor('alert-danger');
                            window.scrollTo(0,0);
                          }
                          else
                          {
                            disableLoading();
                            setSubmitting(false);
                            let allLocations = [];
                            allLocations = locations;
                            allLocations.push({locationName: values.locationName,
                        accountKey:account.accountId,
                        address: values.address,
                        phone:values.phone,
                        email: values.email,
                        countryCode:countryCode,
                        countryName:countryName,
                        stateCode: stateCode,
                        stateName: stateName,
                        districtCode:districtCode,
                        districtName: districtName,
                      locationKey:resp.data});
                        setLocations(allLocations);

                            setStatus(
                              intl.formatMessage({
                                id: "CREATION.SUCCESS.MESSAGE"
                              })
                            );
                            setStatusColor('alert-success');
                            window.scrollTo(0,0);
                            setAddOpen(false);
                          }
                         
                        })
                        .catch(() => {
                          disableLoading();
                          setSubmitting(false);
                          setStatus(
                            intl.formatMessage({
                              id: "AUTH.VALIDATION.INVALID_LOGIN"
                            })
                          );
                          setStatusColor('alert-danger');
                        });
                      }
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,

                    
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      {status && (
                        <div role="alert" className={"alert "+statusColor}>
                          <div className="alert-text">{status}</div>
                        </div>
                      )}

              <CodeExample beforeCodeTitle="Location Details">
              <div className="kt-section">
                <div className="kt-section__content">

                        
                      <div className="row">
                         <div className="col-6">
                            <TextField
                              margin="normal"
                              label="Location Name"
                              className="kt-width-full"
                              name="locationName"
                              autoComplete='off'
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.locationName}
                              helperText={touched.locationName && errors.locationName}
                              error={Boolean(touched.locationName && errors.locationName)}
                            />
                          </div> 


                           <div className="col-6">
                            <TextField
                              margin="normal"
                              label="Address"
                              className="kt-width-full"
                              name="address"
                              autoComplete='off'
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.address}
                              helperText={touched.address && errors.address}
                              error={Boolean(touched.address && errors.address)}
                            />
                          </div>    
                  
                          <div className="col-6">
                              <Autocomplete
                                id="stateCode"
                                name={"stateCode" + "--" +  stateName}
                                value={values.stateCode}
                                options={states}
                                autoComplete={true}
										            clearOnBlur={true}
                                getOptionLabel={(option) => option.stateName}
                                onChange={(event,newValue)=>{stateChange(event,newValue);}}
                                renderInput={(params) => <TextField {...params} autoComplete='off' label={stateName!==null?"State -- "+stateName:"State"}/>}
                              />
                            
                          </div>          

                          <div className="col-6">
                            <Autocomplete
                                id="districtCode"
                                name={"districtCode" + "--" +  districtName}
                                value={values.districtCode}
                                options={districts}
                                autoComplete={true}
										            clearOnBlur={true}
                                getOptionLabel={(option) => option.districtName}
                                onChange={(event,newValue)=>{districtChange(event,newValue);}}
                               renderInput={(params) => <TextField {...params} autoComplete='off'  label={districtName!==null?"County -- "+districtName:"County"}/>}
                              />
                          </div>
                          
                          <div className="col-6">
                            <TextField
                              margin="normal"
                              label="Phone"
                              className="kt-width-full"
                              name="phone"
                              onBlur={handleBlur}
                              autoComplete='off'
                              onChange={handleChange}
                              value={values.phone}
                              helperText={touched.phone && errors.phone}
                              error={Boolean(touched.phone && errors.phone)}
                            />
                          </div>  

                          <div className="col-6">
                            <TextField
                              margin="normal"
                              label="Email"
                              className="kt-width-full"
                              name="email"
                              autoComplete='off'
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.email}
                              helperText={touched.email && errors.email}
                              error={Boolean(touched.email && errors.email)}
                            />
                          </div>  
                      </div>
                      
                      
                </div>

              </div>
            </CodeExample>

        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                              }
                            )}`}
                            style={loadingButtonStyle}
                          >
                           Update
                        </button>
                      </div>
        </form>
         )}
                </Formik>
                 


                    </DialogContent>
      

                    <DialogActions>
                      <Button onClick={handleAddClose} color="primary">
                        Close
                      </Button>
                      
                    </DialogActions>
      
                  </Dialog>

                  

                  
                </>
     
  );
}


export default injectIntl(
  connect(
    null,
    auth.actions
  )(AddLocation)
);
